export const targetingKeys = {
	all: ['targeting'],
	vocabulary: ['targeting', 'vocabulary'],
};
